/* Keep project contents links below the theme's sticky header. */
document.addEventListener('click', function (event) {
  const link = event.target.closest && event.target.closest('.cp-project-guide a[href*="#"]');
  if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
  const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
  if (!target || !target.closest('.cp-project-guide')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const header = document.querySelector('header');
  const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
  const top = window.scrollY + target.getBoundingClientRect().top - headerBottom - 16;
  window.history.replaceState(null, '', url.pathname + url.search + url.hash);
  window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
}, true);
